import { atom } from 'jotai';

/**
 * Atom for controlling the visibility of the Add Lot modal
 */
export const showAddLotModalAtom = atom<boolean>(false);

/**
 * Atom for controlling the visibility of the Bulk Import modal and storing the auction GUID.
 * null = modal closed, string = modal open for that specific auction
 */
export const showBulkImportModalAtom = atom<string | null>(null);
